// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"niDFKnHvH8ug_XJjxXYJR","advantage":"_326vb35oa8zPm1sTGnT20I","title":"_1B5rnBvHqyMLE52J0LG9P4","itemContent":"_1jtOzf4Vi3rbpeTRnBS7T4","error":"sRwAP4joY9I6wxfoCHr5J","addBtnWrapper":"_19I8hCWumqMjvqJElXmG78","addBtn":"_2NUL2HpmIbBuZ6-4QRFHxv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditCompanyByOwnerAdvantages/EditCompanyByOwnerAdvantages.scss
// module id = 1590
// module chunks = 0